import { Controller } from "@hotwired/stimulus";

// ポップアップ作成/編集フォーム用。
// 「特定のキャンペーン参加者だけに表示する」チェックの ON/OFF で、対象キャンペーンの
// select を表示/非表示する。OFF にしたら select を空に戻し、通常ポップアップ扱いにする。
export class CampaignTargetController extends Controller {
  static targets = ["toggle", "field", "select"];

  connect() {
    this.update();
  }

  update() {
    const enabled = this.toggleTarget.checked;
    this.fieldTarget.classList.toggle("d-none", !enabled);
    if (!enabled) {
      this.selectTarget.value = "";
    }
  }
}
